import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './app/store'
import { Provider } from 'react-redux'

const root = ReactDOM.createRoot(document.getElementById('root'));
const BASE_URL = "/admin";

const { pathname, search, hash } = window.location;

if (
  pathname !== BASE_URL &&
  !pathname.startsWith(`${BASE_URL}/`)
) {
  const newPath = `${BASE_URL}${pathname}${search}${hash}`;
  window.location.replace(newPath);
}
root.render(
  <React.StrictMode>
    <Provider store={store}>
        <App />
      </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
